import { render } from "./view.vue?vue&type=template&id=5d482df4&scoped=true"
import script from "./index.js?vue&type=script&lang=js"
export * from "./index.js?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=5d482df4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\FAUZAN\\Documents\\Project\\ore-no-app-fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d482df4"]])

export default __exports__